import { forwardRef } from 'react';

import { DropdownTheme } from '@sternum/dropdown/lib/Dropdown.theme';
import { Dropdown, DropdownProps } from '@sternum/ui';

export interface LocalDropdownProps extends Omit<DropdownProps, 'theme'> {
  localTheme?: Partial<DropdownTheme>;
}

export const LocalDropdown = forwardRef<HTMLDivElement, LocalDropdownProps>((props, ref) => {
  return <Dropdown ref={ref} {...props} theme={props.localTheme} />;
});

LocalDropdown.displayName = 'Dropdown';
